import { render } from "./ImprintView.vue?vue&type=template&id=49505f16"
import script from "./ImprintView.vue?vue&type=script&lang=js"
export * from "./ImprintView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__